import { clsx } from "clsx";

import OnboardingProgress from "./OnboardingProgress";

import type { ReactNode } from "react";

interface NavItemProps {
  isExpanded: boolean;
  isActive?: boolean;
  isInteractive?: boolean;
  isOnboarding?: boolean;
  children: ReactNode;
  icon: ReactNode;
}

export default function NavItem({
  isExpanded,
  icon,
  isActive = false,
  isInteractive = true,
  isOnboarding = false,
  children,
}: NavItemProps) {
  const isCollapsedOnboarding = isOnboarding && !isExpanded;

  return (
    <div
      className={clsx(
        "group flex items-center justify-start gap-x-2.5 rounded-3xl transition-[background,shadow,border] text-nowrap border",
        "border lg:overflow-hidden lg:rounded-2xl lg:gap-x-2",

        isCollapsedOnboarding
          ? "size-9 justify-center items-center p-1.5"
          : "h-12 lg:h-9 px-4 lg:p-2.5",

        isActive
          ? "text-md-bold border-black-100 lg:bg-purple-50 lg:border-purple-50 bg-white max-lg:shadow-md lg:text-purple-500 lg:text-button-xs"
          : [
              "text-md-medium lg:text-xs-medium border-transparent",
              isInteractive &&
                "lg:hover:border-black-200 lg:hover:bg-black-100",
            ],
      )}
    >
      {!isCollapsedOnboarding && (
        <>
          {/* Icon */}
          <span className={clsx("[&_svg]:size-5 lg:[&_svg]:size-4 shrink-0")}>
            {icon}
          </span>

          {/* Content */}
          <span
            className={clsx(
              "flex items-center transition-opacity duration-500 grow",
              isExpanded ? "opacity-100" : "opacity-0",
            )}
          >
            {children}
          </span>
        </>
      )}

      {isOnboarding && <OnboardingProgress />}
    </div>
  );
}
